<script>
	import {External, M} from '../../external';
	import WebComponents from "../../main";

	export let contact, changeTabToNotes;

  const moreClicked = (event) => {
    var items = [];
    if (contact.isMember()) {
      items.push({
        icon: 'fa-lock',
        label: M.RESET_MEMBER_PASSWORD,
        tag: 'password'
      });
      items.push({
        icon: 'fa-users',
        label: M.ASSIGN_COMMUNITY_ROLE,
        tag: 'community-role'
      });
			if (contact.isMuted()) {
				items.push({
					icon: 'fa-comment',
					label: M.UNMUTE,
					tag: 'community-unmute'
				});
			} else {
				items.push({
					icon: 'fa-comment-slash',
					label: M.MUTE,
					tag: 'community-mute'
				});
			}
    } else {
      items.push({
        icon: 'fa-user',
        label: M.MAKE_WEBSITE_MEMBER,
        tag: 'make-member'
      });
    }

		items.push({
			icon: 'fa-trash',
			label: M.DELETE,
			tag: 'delete'
		});

		if (External.Website.isMarketingEnabled()) {
			items.push({
				icon: 'fa-envelope',
				label: contact.data.subscribed ? M.CONTACT_UNSUBSCRIBE : M.SUBSCRIBE,
				tag: 'change-subscribe'
			});
		}

		External.Tools.showFloatingPopupList({
			target: event.target,
			items: items,
			onSelect: function (selected) {
				if (selected.tag === 'password') {
					External.Tools.prompt(M.DEL_CONFIRM, M.PASSWORD_RESET_CONFIRM, contact.resetMemberPassword);
				} else if (selected.tag === 'delete') {
					External.Tools.prompt(M.DELETE_TITLE, M.DEL_CONFIRM, contact.deleteContact);
				} else if (selected.tag === 'make-member') {
					chooseMemberGroups([], function (newGroups) {
						var groupIds = [];
						newGroups.forEach(function (group) {
							groupIds.push(group.id);
						});
						contact.makeMember(groupIds);
					});
				} else if (selected.tag === 'change-subscribe') {
					contact.changeSubscriptionStatus();
				} else if (selected.tag === 'community-role') {
          assignAsCommunityManager(contact.isAdmin(), contact.isModerator(), function (selected) {
            if (selected.length > 0) {
              if (selected[0].id === 0) {
                contact.changeCommunityManagerStatus('admin');
              } else if (selected[0].id === 1) {
                contact.changeCommunityManagerStatus('moderator');
							} else {
                contact.changeCommunityManagerStatus('member');
              }
            }
          });
				} else if (selected.tag === 'community-mute') {
					contact.muteMember();
				} else if (selected.tag === 'community-unmute') {
					contact.unmuteMember();
				}
			}
		});
	};

	const chooseMemberGroups = (currentlyAssignedGroups, onSelect) => {
		External.Tools.chooseMultiple({
			title: M.SELECT_MEMBER_GROUPS,
			message: '',
			noItemsMessage: M.NO_MEMBER_GROUPS,
			items: External.Website.memberGroups,
			selectedItems: currentlyAssignedGroups,
			isModal: true,
			getItemId: function (group) {
				return group.id;
			},
			getItemText: function (group) {
				return group.name;
			},
			onSelect: onSelect
		});
	};

	const composeEmail = (e) => {
		WebComponents.CRM.composeEmail(contact.data);
	};

	const composeMessage = (e) => {
		const target = External.$(e.target ? e.target : e);

		External.Tools.showFloatingPopupList({
			target: target,
			items: External.CRM_MESSAGE_OPTIONS,
			onSelect: function (selected) {
				if (selected.channel === External.CRM_MESSAGE_CHANNEL.SMS) {
					WebComponents.CRM.composeSMS(contact.data);
				} else if (selected.channel === External.CRM_MESSAGE_CHANNEL.WHATSAPP) {
					WebComponents.CRM.composeWhatsApp(contact.data);
				} else if (selected.channel === External.CRM_MESSAGE_CHANNEL.VOICE) {
					WebComponents.CRM.composeVoice(contact.data);
				}
			}
		});
	};

  const assignAsCommunityManager = (isAdmin, isModerator, onSelect) => {
    const options = [
      { id: 0, name: M.COMMUNITY_ADMIN || 'Admin' },
      { id: 1, name: M.COMMUNITY_MODERATOR || 'Moderator' },
      { id: 2, name: M.MEMBER || 'Member' }
    ];

    const selected = [];
    if (isAdmin) {
      selected.push(options[0]);
    }
    if (isModerator) {
      selected.push(options[1]);
    }
    if (!isAdmin && !isModerator) {
      selected.push(options[2]);
    }

    External.Tools.chooseMultiple({
      single: true,
      allowEmptySelection: true,
      title: M.ASSIGN_COMMUNITY_ROLE,
      message: '',
      noItemsMessage: '',
      items: options,
      selectedItems: selected,
      isModal: true,
      getItemId: function (group) {
        return group.id;
      },
      getItemText: function (group) {
        return group.name;
      },
      onSelect: onSelect
    });
  };
</script>

<div class="contact-activity-bar mt-15 flex align-center">
	<a class="contact-circle-action flex flex-col align-center" on:click={composeEmail}>
		<div class="contact-cirle-action-icon rounded-effect">
			<svg height="48" viewBox="0 -960 960 960" width="48" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z"
				></path>
			</svg>
		</div>
		<span class="col20 mt-5">{M.EMAIL}</span>
	</a>
	{#if !window.messagingDisabled}
		<a class="contact-circle-action flex flex-col align-center" on:click={composeMessage}>
			<div class="contact-cirle-action-icon rounded-effect">
				<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
					<path
						d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/>
				</svg>
			</div>
			<span class="col20 mt-5">{M.MESSAGE}</span>
		</a>
	{/if}
	<a class="contact-circle-action flex flex-col align-center" on:click={changeTabToNotes}>
		<div class="contact-cirle-action-icon rounded-effect">
			<svg height="48" viewBox="0 -960 960 960" width="48" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M286-289h60l255-255-59-61-256 256v60Zm333-273 39-39q7-7 7.5-15.5T658-633l-29-28q-8-8-16-7.5t-15 7.5l-38 38 59 61ZM180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v600q0 24.75-17.625 42.375T780-120H180Zm0-60h600v-600H180v600Zm300-617q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM180-180v-600 600Z"
				></path>
			</svg>
		</div>
		<span class="col20 mt-5">{M.NOTE}</span>
	</a>
	<a class="contact-circle-action flex flex-col align-center" on:click={moreClicked}>
		<div class="contact-cirle-action-icon rounded-effect">
			<svg height="48" viewBox="0 -960 960 960" width="48" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M207.858-432Q188-432 174-446.142q-14-14.141-14-34Q160-500 174.142-514q14.141-14 34-14Q228-528 242-513.858q14 14.141 14 34Q256-460 241.858-446q-14.141 14-34 14Zm272 0Q460-432 446-446.142q-14-14.141-14-34Q432-500 446.142-514q14.141-14 34-14Q500-528 514-513.858q14 14.141 14 34Q528-460 513.858-446q-14.141 14-34 14Zm272 0Q732-432 718-446.142q-14-14.141-14-34Q704-500 718.142-514q14.141-14 34-14Q772-528 786-513.858q14 14.141 14 34Q800-460 785.858-446q-14.141 14-34 14Z"
				></path>
			</svg>
		</div>
		<span class="col20 mt-5">{M.MORE}</span>
	</a>
</div>
